"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createRouter: () => createRouter
});
module.exports = __toCommonJS(src_exports);
var import_history = require("history");
var import_path_parser = require("path-parser");
var import_query_string = __toESM(require("query-string"));
function createRouter(config, {
  base
} = {}) {
  const routes = [];
  const history = (0, import_history.createBrowserHistory)();
  if (base === "/") {
    base = "";
  } else if (base && base[0] !== "/") {
    base = "/" + base;
  }
  for (const route in config) {
    routes.push({
      name: route,
      path: new import_path_parser.Path(base ? base + config[route] : config[route]),
      get params() {
        return this.path.test(history.location.pathname) || {};
      },
      get pathname() {
        return history.location.pathname.substring(base?.length ?? 0);
      }
    });
  }
  function getRoute(name) {
    const route = routes.find((route2) => route2.name === name);
    if (!route) {
      throw new Error("Can not find route for " + String(name));
    }
    return route;
  }
  function getActiveRoute() {
    return routes.find((route) => route.path.test(history.location.pathname));
  }
  const listeners = /* @__PURE__ */ new Set();
  function notify(update) {
    if (update.action === import_history.Action.Replace && // @ts-ignore
    update.location.state?.isQueryUpdate) {
      return;
    }
    const activeRoute = getActiveRoute();
    listeners.forEach(
      (listener) => (
        // We change reference as the route is considered new
        listener(activeRoute ? { ...activeRoute } : void 0)
      )
    );
  }
  history.listen(notify);
  return {
    url(name, params) {
      const route = getRoute(name);
      return route.path.build(params);
    },
    push(name, params, query = {}) {
      const route = getRoute(name);
      history.push({
        pathname: route.path.build(params),
        search: import_query_string.default.stringify(query)
      });
    },
    replace(name, params, query = {}) {
      const route = getRoute(name);
      history.replace({
        pathname: route.path.build(params),
        search: import_query_string.default.stringify(query)
      });
    },
    setQuery(key, value) {
      let existingQuery = import_query_string.default.parse(history.location.search);
      if (value === void 0) {
        delete existingQuery[key];
      } else {
        existingQuery = {
          ...existingQuery,
          [key]: value
        };
      }
      history.replace(
        {
          pathname: history.location.pathname,
          search: "?" + import_query_string.default.stringify(existingQuery)
        },
        {
          isQueryUpdate: true
        }
      );
    },
    listen(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    get current() {
      return getActiveRoute();
    },
    get queries() {
      return import_query_string.default.parse(history.location.search);
    },
    get pathname() {
      return history.location.pathname.substring(base?.length ?? 0);
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createRouter
});
